var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout position-ref full-height"},[_c('o-child')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }